import { Container } from 'inversify';
import { FC, ReactElement, ReactNode } from 'react';
import { ProviderContext } from './IocContext';

type IocProviderProps = {
  container: Container;
  children: ReactNode;
};

export const IocProvider: FC<IocProviderProps> = ({ container, children }): ReactElement => {
  return <ProviderContext.Provider value={container}>{children}</ProviderContext.Provider>;
};
